module.exports = __webpack_public_path__ + "static/q4-a646d6918b9394165905e8ce5685151b.png";